export enum CourseAnalyticsTab {
  STUDENTS = 'students',
  AVERAGES = 'averages',
}
